import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LoadAnim from "../components/LoadAnim";
import Grid from "../components/Grid";
import Button from "../components/Button";

// Register GSAP ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export default function Home({ setView, setPortfolioindex }) {
  const titleRef = useRef(null);

  useEffect(() => {
    // GSAP scroll animation
    if (titleRef.current) {
      gsap.fromTo(
        titleRef.current,
        { y: 0, opacity: 1 }, // Start position: visible
        {
          y: 100, // Move upwards when scrolling down
          opacity: 0, // Fade out
          scrollTrigger: {
            trigger: titleRef.current,
            start: "top top", // When the top of the title hits the top of the viewport
            end: "bottom top", // End when the bottom of the title reaches the top of the viewport
            scrub: 1, // Smoothly scrub the animation with scroll
            toggleActions: "play none none reverse", // Play on scroll, reverse on scroll up
          },
        }
      );
    }
  }, []);

  const paragraphRef = useRef(null);

  useEffect(() => {
    // GSAP scroll animation
    if (paragraphRef.current) {
      gsap.fromTo(
        paragraphRef.current,
        { y: 0, opacity: 1 }, // Start position: visible
        {
          y: 150, // Move upwards when scrolling down
          opacity: 0, // Fade out
          scrollTrigger: {
            trigger: paragraphRef.current,
            start: "top top", // When the top of the title hits the top of the viewport
            end: "bottom top", // End when the bottom of the title reaches the top of the viewport
            scrub: 1, // Smoothly scrub the animation with scroll
            toggleActions: "play none none reverse", // Play on scroll, reverse on scroll up
          },
        }
      );
    }
  }, []);

  return (
    <div>
      <div
        ref={titleRef}
        className="title px-[70px] relative pb-[0] pt-[100px] overflow-hidden flex flex-col items-center"
      >
        <LoadAnim>
          <h2 className="smooth font-florian text-white text-[90px] font-light leading-[100%] tracking-[5px]">
            SIMO DJUKANOVIC
          </h2>
        </LoadAnim>
        <LoadAnim>
          <h2 className="smooth font-florian  text-white text-[50px] font-light leading-[120%] tracking-[3px]">
            <span className="text-[#7c0000]"> videographer</span>
          </h2>
        </LoadAnim>
      </div>
      <div ref={paragraphRef} className="pl-[70px] pb-[20px] pt-[70px]">
        <LoadAnim>
          <h1 className="smooth font-[300] text-white text-[30px] leading-[120%]">
            <span className="text-[#7c0000]">Profesionalni videograph</span>
          </h1>
        </LoadAnim>
        <LoadAnim>
          <p className="mt-[15px] text-white text-[18px] font-light leading-[140%] max-w-[650px] tracking-[1px]">
            I've spent the last 5 years building and scaling software for some
            pretty cool companies. I also teach people to paint online (incase
            you've got an empty canvas layin' around 🎨). Let's connect!
          </p>
        </LoadAnim>
        <LoadAnim className="mt-[20px]">
          <Button>Kontakt</Button>
        </LoadAnim>
      </div>

      <div>
        <Grid setPortfolioindex={setPortfolioindex} setView={setView} />
      </div>
    </div>
  );
}
